import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { StraightShooterGameCoreService } from './straight-shooter-game-core.service';
import { StraightShooterGameSelectorComponent } from './straight-shooter-game-selector/straight-shooter-game-selector.component';

@NgModule({
  declarations: [StraightShooterGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [StraightShooterGameCoreService],
  exports: [StraightShooterGameSelectorComponent],
})
export class StraightShooterGameCoreModule {}
